// removed by extract-text-webpack-plugin
module.exports = {"header":"lb_bg","avatar":"lb_fm","name":"lb_m","description":"lb_o"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/ReviewList/components/ReviewListItem/styles.module.css
// module id = 1305
// module chunks = 27